import type { IconProps } from './IconLibrary';

function TreeIcon({ size = 40, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" {...props}>
      <path
        d="M17.5 22 L16 36 Q20 37.5 24 36 L22.5 22 Z"
        fill="#8a5a3b"
        stroke="#2f2f2f"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M20 3
           C13 3 9 8 10.5 13
           C7 14 5.5 18.5 8.5 21.5
           C6.5 25 9.5 29 14 28
           C16 30.5 24 30.5 26 28
           C30.5 29 33.5 25 31.5 21.5
           C34.5 18.5 33 14 29.5 13
           C31 8 27 3 20 3 Z"
        fill="#5c9e5c"
        stroke="#2f2f2f"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default TreeIcon;
